let more = true;
let category = 0;
let page = 1;
let maxPage = 0;
$(function () {
    category = $("#rd_category_id").data("id");
    maxPage = $("#rd_product_max_page").data("page");

    if ($("#rd-section-pro1").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-pro1",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-pro1").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-pro2").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-pro2",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-pro2").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-pro3").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-pro3",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-pro3").addClass("ani_do").removeClass("op0");
            },
        });
    }
    let productSwiper = new Swiper(".pro_swiper", {
        slidesPerView: 2,
        spaceBetween: 20,
        breakpoints: {
            1024: {
                slidesPerView: 4,
                grid: {
                    rows: 1,
                },
            },
            360: {
                slidesPerGroup: 2,
                grid: {
                    fill: "row",
                    rows: 2,
                },
            },
        },
        scrollbar: {
            el: ".pro_cata_scroll",
            scrollbarDraggable: false,
        },
        navigation: {
            nextEl: ".sw_right",
            prevEl: ".sw_left",
        },
        on: {
            reachBeginning: function () {
                $("#rd_category_left").addClass("gray");
                $("#rd_category_right").removeClass("gray");
            },
            slideChange: function () {
                let currentIndex = this.activeIndex;
                if (currentIndex > 0) {
                    $("#rd_category_left").removeClass("gray");
                }
                if ($(window).width() >= 1024) {
                    if (currentIndex < this.slides.length - 4) {
                        $("#rd_category_right").removeClass("gray");
                    }
                } else {
                    if (currentIndex < Math.ceil(this.slides.length / 4)) {
                        $("#rd_category_right").removeClass("gray");
                    }
                }
            },
            reachEnd: function () {
                let currentIndex = this.activeIndex;
                if (currentIndex == 0) {
                    $("#rd_category_right").addClass("gray");
                    $("#rd_category_left").addClass("gray");
                } else {
                    $("#rd_category_right").addClass("gray");
                    $("#rd_category_left").removeClass("gray");
                }
            },
        },
    });

    $(window).on("resize", function (e) {
        productSwiper.destroy();
        productSwiper = new Swiper(".pro_swiper", {
            slidesPerView: 2,
            spaceBetween: 20,
            breakpoints: {
                1024: {
                    slidesPerView: 4,
                    grid: {
                        rows: 1,
                    },
                },
                360: {
                    slidesPerGroup: 2,
                    grid: {
                        fill: "row",
                        rows: 2,
                    },
                },
            },
            scrollbar: {
                el: ".pro_cata_scroll",
                scrollbarDraggable: false,
            },
            navigation: {
                nextEl: ".sw_right",
                prevEl: ".sw_left",
            },
            on: {
                init: function () {
                    if (this.slides.length > 4) {
                        $("#rd_category_left").addClass("gray");
                        $("#rd_category_right").removeClass("gray");
                    }
                },
                reachBeginning: function () {
                    $("#rd_category_left").addClass("gray");
                    $("#rd_category_right").removeClass("gray");
                },
                slideChange: function () {
                    let currentIndex = this.activeIndex;
                    if (currentIndex > 0) {
                        $("#rd_category_left").removeClass("gray");
                    }
                    if ($(window).width() >= 1024) {
                        if (currentIndex < this.slides.length - 4) {
                            $("#rd_category_right").removeClass("gray");
                        }
                    } else {
                        if (currentIndex < Math.ceil(this.slides.length / 4)) {
                            $("#rd_category_right").removeClass("gray");
                        }
                    }
                },
                reachEnd: function () {
                    let currentIndex = this.activeIndex;
                    if (currentIndex == 0) {
                        $("#rd_category_right").addClass("gray");
                        $("#rd_category_left").addClass("gray");
                    } else {
                        $("#rd_category_right").addClass("gray");
                        $("#rd_category_left").removeClass("gray");
                    }
                },
            },
        });
    });
    $(".rd_category").on("click", function () {
        $(".rd_category").removeClass("now");
        $(this).addClass("now");
        category = $(this).data("id");
        page = 0;
        more = true;
        maxPage = $(this).data("page");
        if (maxPage > 1) {
            $("#rd_more").show();
        }
        $("#rd-section-pro3").html("");
        productMore();
    });

    $("#rd_more").on("click", function () {
        productMore();
    });
});

function productMore() {
    if (more) {
        $("#rd_loading").show();
        more = false;
        page++;
        $.ajax({
            type: "GET",
            url: $("#rd_more_url").data("url"),
            data: `category=${category}&page=${page}`,
            cache: false,
            success: function (response) {
                $("#rd-section-pro3").append(response);

                $("#rd_loading").hide();

                if (page == maxPage) {
                    $("#rd_more").hide();
                } else {
                    more = true;
                }
            },
            error: function (e) {
                $("#rd_more").hide();
                $("#rd_loading").hide();
            },
        });
    }
}
